import apiFetch from '../apiFetch'

export default function (value, token) {
  return apiFetch({endPoint: `ImportarContactosExcel/descargarPlantillaExcelContactosExcel`, method: 'GET', body: null, token: token})
}
